var render = function () {
  var _this = this;

  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-select', {
    staticClass: "w-100 mw-md-200px",
    attrs: {
      "value": _vm.sort,
      "items": _vm.sortMethods,
      "outlined": "",
      "hide-details": ""
    },
    on: {
      "input": function input(sort) {
        return _vm.$router.push({
          query: Object.assign({}, _this.$route.query, {
            sort: sort,
            page: 1
          })
        });
      }
    }
  });
}
var staticRenderFns = []

export { render, staticRenderFns }